export const getFooterStyle = (vw) => {
  return {
    area: {
      height: `calc((104 / ${vw}) * 100vw + calc(env(safe-area-inset-bottom)`,
      paddingLeft: `calc((12 / ${vw}) * 100vw)`,
      paddingRight: `calc((12 / ${vw}) * 100vw)`,
      paddingBottom: `calc((10 / ${vw}) * 100vw + calc(env(safe-area-inset-bottom) +  (12 / ${vw}) * 100vw))`,
    },
    secondary: {
      height: `calc((60 / ${vw}* 100vw))`,
      borderRadius: `calc((15 / ${vw})* 100vw)`,
      padding: `calc(20 / ${vw}* 100vw)`,
    },
    text: { fontSize: `calc((20 / ${vw})* 100vw)` },
  };
};
